import { render, staticRenderFns } from "./registryEntries-calendar.vue?vue&type=template&id=06bfef0a&scoped=true&"
import script from "./registryEntries-calendar.vue?vue&type=script&lang=js&"
export * from "./registryEntries-calendar.vue?vue&type=script&lang=js&"
import style0 from "./registryEntries-calendar.vue?vue&type=style&index=0&id=06bfef0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfef0a",
  null
  
)

export default component.exports